import { useDispatch } from 'react-redux';
import { downloadProfileReport } from '../../../adminSlice';

export default function ProfileReportDownload({ profileId }) {
    const dispatch = useDispatch();

    const downloadFile = async (profileId) => {
        try {
          const resultAction = await dispatch(downloadProfileReport(profileId));
          if (downloadProfileReport.fulfilled.match(resultAction)) {
            const blob = resultAction.payload;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `profile_report_${profileId}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } catch (error) {
          console.error('Download failed:', error);
        }
      };

    return (
        <button
            type="button"
            onClick={() => downloadFile(profileId)}
            className="inline-flex h-9 w-9 flex-none items-center justify-center rounded-lg text-[#211b4f] transition-colors hover:bg-[#211b4f]/5 focus:outline-none focus:ring-2 focus:ring-[#211b4f] focus:ring-offset-2"
            aria-label={`Download report for profile ${profileId}`}
            title="Download report"
        >
            <svg
                className="h-5 w-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 18"
            >
                <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8 1v11m0 0 4-4m-4 4L4 8m11 4v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3"
                />
            </svg>
        </button>
    )
}
